export default __webpack_public_path__ + "edded257998573fa6d8da449e0797fac.svg";